module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc3-4a04c409a8b641253dc10ba39daa3ce8.jpg";